import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = unknown / not logged
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("kayama_token");
        if (!token) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => {
                localStorage.removeItem("kayama_token");
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, []);

    async function login(email, password) {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("kayama_token", data.token);
            const me = await api.get("/auth/me");
            setUser(me.data);
            return { ok: true };
        } catch (err) {
            return { ok: false, error: formatApiError(err, "Identifiants invalides") };
        }
    }

    function logout() {
        localStorage.removeItem("kayama_token");
        setUser(null);
    }

    return (
        <AuthContext.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
